import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '../../../group_leader/components/common'
import { sharedT } from '../../../group_leader/helpers/i18n'

// The fixed bar at the bottom of every step: Back left, the primary action right, an optional hint.

const WizardFooter = ({
  onBack,
  onPrimary,
  primaryLabel,
  primaryDisabled = false,
  primaryLoading = false,
  primaryWide = false,
  hint,
  hintPosition = 'end',
}) => (
  <div className="gl-event-setup-bottom-bar">
    <div className="gl-event-setup-bottom-bar-inner">
      <div className="gl-event-setup-bottom-bar-actions">
        {onBack && (
          <Button variant="secondary" size="lg" onClick={onBack}>
            {sharedT('back')}
          </Button>
        )}
        {hintPosition === 'start' && hint && <div className="gl-event-setup-bot-hint">{hint}</div>}
      </div>
      <div className="gl-event-setup-bottom-bar-actions">
        {hintPosition === 'end' && hint && <div className="gl-event-setup-bot-hint">{hint}</div>}
        <Button
          variant="primary"
          size="lg"
          wide={primaryWide}
          onClick={onPrimary}
          disabled={primaryDisabled}
          loading={primaryLoading}
        >
          {primaryLabel}
        </Button>
      </div>
    </div>
  </div>
)

WizardFooter.propTypes = {
  onBack: PropTypes.func,
  onPrimary: PropTypes.func.isRequired,
  primaryLabel: PropTypes.node.isRequired,
  primaryDisabled: PropTypes.bool,
  // Spinner in the primary button while its action runs; disables it too
  primaryLoading: PropTypes.bool,
  primaryWide: PropTypes.bool,
  hint: PropTypes.node,
  // 'start' puts the hint in the left slot — for a first step, which has no Back
  hintPosition: PropTypes.oneOf([ 'start', 'end' ]),
}

export default WizardFooter
